import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class TabHeader extends ThemeComponent {
    @Ref buttons !: HTMLButtonElement[];

    private tab: string = '';

    private _onTabChange = new SimpleEvent<string>();

    public get onTabChange() {
        return this._onTabChange.asEvent();
    }

    public changeTab(tab: string) {
        this.tab = tab;

        // Use the private backing field to dispatch
        this._onTabChange.dispatch(tab);
    }

    init() {
        for (const button of this.buttons) {
            this.$listen(button, 'click', () => {
                const value = button.value;
                if (value) {
                    this._onTabChange.dispatch(value);
                }
            });
        }
    }
}
